import { cn } from "../lib/utils"
import { useAtom } from "jotai"
import { isSuperAdminAtom, isGuideAtom, isOrgAdminAtom, isGuideAdminAtom } from "../state"
import { Link, useNavigate } from "react-router-dom"
import { useCallback } from "react"

export const SideBarButton = ({
  visibleToGuide = false,
  adminOnly = true,
  route,
  title,
  firstOfGroup = false,
  iconClassName,
  onClick = undefined,
}) => {
  const [isSuperAdmin] = useAtom(isSuperAdminAtom)
  const [isGuideAdmin] = useAtom(isGuideAdminAtom)
  const [isGuide] = useAtom(isGuideAtom)
  const [isOrgAdmin] = useAtom(isOrgAdminAtom)
  const navigate = useNavigate()

  const handleClick = useCallback(() => {
    if (onClick) {
      return onClick()
    }
    return navigate(route)
  }, [onClick, route, navigate])

  const isAdminUserType = isOrgAdmin || isSuperAdmin || isGuideAdmin;
  const isGuideUserType = isGuideAdmin || isGuide;

  const shouldShowToGuide = visibleToGuide && isGuideUserType
  const shouldShowToAdmin = adminOnly && isAdminUserType
  const shouldShow = (!adminOnly || !visibleToGuide) || shouldShowToAdmin || shouldShowToGuide

  if (!shouldShow) {
    return null
  }

  if (!route && onClick) {
    return (
      <button
        className={cn(
          "group flex items-center gap-4 border-t px-4 py-2 leading-5",
          firstOfGroup ? "border-t-neutral-400" : "border-t-neutral-200",
        )}
        onClick={handleClick}
      >
        <i
          className={cn(
            "rounded bg-brand/80 p-2 text-white group-hover:bg-brand",
            iconClassName ?? "fa-solid fa-users",
          )}
        ></i>
        <span className="text-sm font-bold uppercase text-brand/80 group-hover:text-brand">
          {title}
        </span>
      </button>
    )
  }

  return (
    <Link
      to={route}
      className={cn(
        "group flex items-center gap-4 border-t px-4 py-2 leading-5",
        firstOfGroup ? "border-t-neutral-400" : "border-t-neutral-200",
      )}
    >
      <i
        className={cn(
          "rounded bg-brand/80 p-2 text-white group-hover:bg-brand",
          iconClassName ?? "fa-solid fa-users",
        )}
      ></i>
      <span className="text-sm font-bold uppercase text-brand/80 group-hover:text-brand">
        {title}
      </span>
    </Link>
  )
}
